const TOOLTIP_CLASS = 'ag-cell-full-name-tooltip'

export const hideGridTooltip = () => {
  document.querySelectorAll(`.${TOOLTIP_CLASS}`).forEach(node => node.remove())
}

export const showGridTooltip = (text, anchor) => {
  hideGridTooltip()
  if (!text || !anchor) return
  const tip = document.createElement('div')
  tip.className = TOOLTIP_CLASS
  tip.textContent = text
  document.body.appendChild(tip)
  const rect = anchor.getBoundingClientRect()
  const top = Math.min(rect.bottom + 8, window.innerHeight - tip.offsetHeight - 8)
  const left = Math.min(Math.max(8, rect.left), window.innerWidth - tip.offsetWidth - 8)
  tip.style.top = `${Math.max(8, top)}px`
  tip.style.left = `${left}px`
}
